import { Link } from 'react-router-dom';

export function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center px-5 py-12 text-center">
      <span
        className="material-symbols-outlined text-gray-300 mb-6"
        style={{ fontSize: 64 }}
        aria-hidden="true"
      >
        potted_plant
      </span>

      <h2 className="font-display text-3xl italic text-editorial-black">
        Welcome, plant parent!
      </h2>

      <p className="mt-3 max-w-xs text-base font-serif text-gray-500">
        Let&rsquo;s meet your first green friend. Point your camera at any houseplant.
      </p>

      {/* Steps */}
      <div className="mt-8 w-full max-w-sm space-y-3">
        <div className="flex items-center gap-4 border border-gray-200 bg-white rounded-lg p-4 text-left">
          <span className="material-symbols-outlined text-editorial-gold" style={{ fontSize: 28 }} aria-hidden="true">
            photo_camera
          </span>
          <div>
            <p className="font-display font-bold text-editorial-black">Snap a photo</p>
            <p className="text-sm font-serif text-gray-400">We&rsquo;ll identify it instantly</p>
          </div>
        </div>
        <div className="flex items-center gap-4 border border-gray-200 bg-white rounded-lg p-4 text-left">
          <span className="material-symbols-outlined text-primary" style={{ fontSize: 28 }} aria-hidden="true">
            menu_book
          </span>
          <div>
            <p className="font-display font-bold text-editorial-black">Get care tips</p>
            <p className="text-sm font-serif text-gray-400">Personalized for your plant</p>
          </div>
        </div>
        <div className="flex items-center gap-4 border border-gray-200 bg-white rounded-lg p-4 text-left">
          <span className="material-symbols-outlined text-status-green" style={{ fontSize: 28 }} aria-hidden="true">
            water_drop
          </span>
          <div>
            <p className="font-display font-bold text-editorial-black">Track watering</p>
            <p className="text-sm font-serif text-gray-400">Never overwater again</p>
          </div>
        </div>
      </div>

      <Link
        to="/add"
        className="btn-editorial mt-8 group"
      >
        <span>Add my first plant</span>
        <span className="material-symbols-outlined group-hover:translate-x-1 transition-transform" style={{ fontSize: 20 }} aria-hidden="true">
          arrow_forward
        </span>
      </Link>

      <p className="mt-4 text-xs font-sans text-gray-400">
        Or add manually if you already know your plant
      </p>
    </div>
  );
}
